module.exports = __webpack_public_path__ + "media/images/sample_img02-e693c91772e9c368a723f91484ddf5f3.png";